module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aleg9-ea5f3caaca5b3e2f74f1200af30f8754.jpg";